import React from "react"

export default function DocumentGenerationModal({
  docType,
  setDocType,
  stock,
}) {
  return (
    docType && (
      <div className="modal-backdrop show d-flex align-items-center justify-content-center">
        <div
          className="modal-content rounded shadow-lg"
          style={{ width: "90%", maxWidth: "450px" }}
        >
          <div className="modal-header py-3">
            <h5 className="modal-title fw-semibold">Generate {docType}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setDocType("")}
            ></button>
          </div>
          <div className="modal-body py-3">
            <p>
              Generate {docType} for {stock?.brand?.name} {stock?.model?.name}?
            </p>
          </div>
          <div className="modal-footer py-3">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setDocType("")}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-primary">
              Generate
            </button>
          </div>
        </div>
      </div>
    )
  )
}
